export enum UploadType {
    Company = 'Company',
    Group = 'Group',
    Instance = 'Instance',
    Profile = 'Profile',
    Room = 'Room',
    Site = 'Site',
}
